<template>
  <footer class="bg-lightgray border-t border-white">
    <div class="grid sm:grid-cols-3 px-6 py-8">
      <ul class="mx-auto sm:mx-0 flex item-info items-center">
        <li><a href="https://www.instagram.com/acyuzuriha/" target="_blank"><img src="../assets/common/icon-insta.svg"/></a>
        </li>
        <li><a href="https://www.facebook.com/acyuzuriha/" target="_blank"><img src="../assets/common/icon-fb.svg"/></a>
        </li>
        <li class="leading-none"><a class="hover:underline text-xs tracking-wide flex items-center font-bold"
                                    href="https://yuzuriha.theshop.jp/" target="_blank"><img class="mr-2" width="15"
                                                                                             src="../assets/common/icon-store.png"/>ゆずりはのジャム</a>
        </li>
      </ul>
      <img class="mx-auto mt-8 mb-6 sm:my-0" src="../assets/top/footer_logo.png" width="117"/>
      <small class="text-center sm:text-right">© yuzuriha</small>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style lang="scss" scoped>
.footer-link {
  a {
    @apply underline hover:no-underline text-sm;
  }

}
</style>